import type { ReactNode } from "react";

interface SectionTitleProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
}

export default function SectionTitle({ title, subtitle, action }: SectionTitleProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4 md:mb-6">
      <div className="flex items-end gap-3">
        <span className="mb-1 h-6 w-1 rounded-full bg-accent-500 md:h-7" />
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            {title}
          </h2>
          {subtitle && (
            <p className="mt-1 text-xs text-foreground-600 md:text-sm">{subtitle}</p>
          )}
        </div>
      </div>
      {action}
    </div>
  );
}